import lrz from 'lrz'
import {
  Toast
} from 'vant';

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function parseQueryString(url, str) { //url参数转换为对象
  const urlObject = {}
  if (/\?/.test(url)) {
    let urlString = url.substring(url.indexOf('?') + 1)
    if (urlString.indexOf(str) > -1) {
      urlString = urlString.replace(`#/${str}?`, '&')
    }
    const urlArray = urlString.split('&')
    urlArray.map((data) => {
      const urlItem = data
      const item = urlItem.split('=')
      urlObject[item[0]] = item[1]
    })

  }
  return urlObject
}

export function getQueryString(url, key) { // url切割
  const queryObject = parseQueryString(url)
  if (Object.keys(queryObject).length > 0) {
    return queryObject[key]
  } else {
    return ''
  }
}
export function compressFile(file, files) { // 上传文件压缩
  return new Promise((resolve, reject) => {
    lrz(file.raw, {
      width: 1000,
      quality: 0.8,
      fieldName: file.name
    }).then((rst) => {
      let fileObj = dataURLtoFile(rst.base64, file.name) // 将base64转换为文件
      let obj = JSON.parse(JSON.stringify(file))
      obj.raw = fileObj
      let newFile = Object.assign({}, file, obj)
      resolve(newFile)
    }).catch(err => {
      this.$fm('上传失败')
      files.splice(files.length - 1, 1)
      reject(err)
    })
  })
}
export function dataURLtoFile(dataurl, filename) { // 将base64转换为文件
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: mime
  })
}


export function getTerminalType() {
  return new Promise(resolve => {
    //获取navigator对象
    var o = navigator.userAgent,
      t = "";
    if (/\biPhone\b|\biPad\b/.test(o) && !/android/i.test(o)) {
      t = "ios";
    } else if (/android/i.test(o)) {
      t = "android";
    }
    // else if (/windows/i.test(o)) {
    //   t = "windows";
    // }
    else {
      t = "pc"
    }
    resolve(t)
  })
}
const imgType = ['image/png', 'image/jpeg']
export function judgeUploadFile(file, other = '') { //校验上传文件公用方法
  return new Promise((resolve, reject) => {
    if (Array.isArray(file)) {
      let isGoOn = true
      file.forEach(item => {
        if (imgType.includes(item.type)) {
          if (item.size / 1024 / 1024 > 10) {
            Toast.fail('上传图片不能超过10mb')
            isGoOn = false
          }
        } else if (item.type == 'application/pdf') {
          if (item.size > 5242880) {
            Toast.fail('上传文件不能超过5mb')
            isGoOn = false
          }
        } else if (other && item.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          if (item.size > 5242880) {
            Toast.fail('上传PDF不能超过5mb')
            isGoOn = false
          }
        } else {
          Toast.fail(`只能上传图片、PDF文件${other}`);
          isGoOn = false
        }
      })
      if (isGoOn) {
        resolve()
      } else {
        reject()
      }
    } else {
      if (imgType.includes(file.type)) {
        if (file.size / 1024 / 1024 > 10) {
          Toast.fail('上传图片不能超过10mb')
          reject()
        } else {
          resolve()
        }
      } else if (file.type == 'application/pdf') {
        if (file.size > 5242880) {
          Toast.fail('上传PDF不能超过5mb')
          reject()
        } else {
          resolve()
        }
      } else if (other && file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        if (file.size > 5242880) {
          Toast.fail('上传Word文档不能超过5mb')
          reject()
        } else {
          resolve()
        }
      } else {
        Toast.fail(`只能上传图片、PDF文件${other}`);
        reject()
      }
    }
  })
}

//阻止页面返回
import * as dd from "dingtalk-jsapi";
export function stopBackPageFun() {
  history.pushState(null, null, document.URL);
  window.addEventListener("popstate", function () {
    history.pushState(null, null, document.URL);
  });
  dd.biz.navigation.setLeft({
    control: true, //是否控制点击事件，true 控制，false 不控制， 默认false
    text: " ", //控制显示文本，空字符串表示显示默认文本
    onSuccess: function (result) { },
    onFail: function (err) { },
  });
}

export function transform(data) {
  return new Promise(async resolve => {
    let fr = new FileReader()
    fr.onload = () => {
      resolve(JSON.parse(fr.result))
    }
    fr.readAsText(data, ['utf-8'])
  })
}
export function changeMoneyToChinese(money) { // 转换金额为中文大写
  var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字  
  var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位  
  var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位  
  var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位  
  //var cnInteger = "整"; //整数金额时后面跟的字符  
  var cnIntLast = "元"; //整型完以后的单位  
  var maxNum = 999999999999999.9999; //最大处理的数字  

  var IntegerNum; //金额整数部分  
  var DecimalNum; //金额小数部分  
  var ChineseStr = ""; //输出的中文金额字符串  
  var parts; //分离金额后用的数组，预定义  
  if (money == "") {
    return "";
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    $.alert('超出最大处理数字');
    return "";
  }
  if (money == 0) {
    //ChineseStr = cnNums[0]+cnIntLast+cnInteger;  
    ChineseStr = cnNums[0] + cnIntLast
    //document.getElementById("show").value=ChineseStr;  
    return ChineseStr;
  }
  money = money.toString(); //转换为字符串  
  if (money.indexOf(".") == -1) {
    IntegerNum = money;
    DecimalNum = '';
  } else {
    parts = money.split(".");
    IntegerNum = parts[0];
    DecimalNum = parts[1].substr(0, 4);
  }
  if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换  
    let zeroCount = 0;
    let IntLen = IntegerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = IntegerNum.substr(i, 1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          ChineseStr += cnNums[0];
        }
        zeroCount = 0; //归零  
        ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        ChineseStr += cnIntUnits[q];
      }
    }
    ChineseStr += cnIntLast;
    //整型部分处理完毕  
  }
  if (DecimalNum != '') { //小数部分  
    const decLen = DecimalNum.length;
    for (let i = 0; i < decLen; i++) {
      const n = DecimalNum.substr(i, 1);
      if (n != '0') {
        ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (ChineseStr == '') {
    //ChineseStr += cnNums[0]+cnIntLast+cnInteger;  
    ChineseStr += cnNums[0] + cnIntLast;
  }
  /* else if( DecimalNum == '' ){ 
              ChineseStr += cnInteger; 
              ChineseStr += cnInteger; 
          } */
  return ChineseStr;
}
export function splitMoney(v) {
  if (!v) return false
  const obj = {}
  const val = String(parseInt(v * 100))
  const len = val.length
  obj.f = val[len - 1] ? val[len - 1] : null
  obj.j = val[len - 2] ? val[len - 2] : null
  obj.y = val[len - 3] ? val[len - 3] : null
  obj.s = val[len - 4] ? val[len - 4] : null
  obj.b = val[len - 5] ? val[len - 5] : null
  obj.q = val[len - 6] ? val[len - 6] : null
  obj.w = val[len - 7] ? val[len - 7] : null
  obj.sw = val[len - 8] ? val[len - 8] : null

  return obj
}

/* export function resizeScreen(refs) { // 移动端屏幕横屏,适配机型
  const _this = this;
  // 利用 CSS3 旋转 对根容器逆时针旋转 90 度
  const detectOrient = function () {
    let width = document.documentElement.clientWidth,
      height = document.documentElement.clientHeight,
      $wrapper = refs, // 这里是页面最外层元素
      style = "";
    if (width >= height) {
      // 横屏
      style += "width:" + width + "px;"; // 注意旋转后的宽高切换
      style += "height:" + height + "px;";
      style += "-webkit-transform: rotate(0); transform: rotate(0);";
      style += "-webkit-transform-origin: 0 0;";
      style += "transform-origin: 0 0;";
    } else {
      // 竖屏
      style += "width:" + height + "px;";
      style +=
        "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
      // 注意旋转中点的处理
      style +=
        "-webkit-transform-origin: 50% 50%;";
      style += "transform-origin:  50% 50%;";
    }
    $wrapper.style.cssText = style;
  };
  window.onresize = detectOrient;
  detectOrient();
} */

export function resizeScreen(refs) { // 移动端屏幕横屏
  const _this = this;
  // 利用 CSS3 旋转 对根容器逆时针旋转 90 度
  const detectOrient = function () {
    let width = document.documentElement.clientWidth,
      height = document.documentElement.clientHeight,
      $wrapper = refs, // 这里是页面最外层元素
      style = "";
    if (width >= height) {
      // 横屏
      style += "width:" + width + "px;"; // 注意旋转后的宽高切换
      style += "height:" + height + "px;";
      style += "-webkit-transform: rotate(0); transform: rotate(0);";
      style += "-webkit-transform-origin: 0 0;";
      style += "transform-origin: 0 0;";
    } else {
      // 竖屏
      style += "width:" + height + "px;";
      style += "height:" + width + "px;";
      style +=
        "-webkit-transform: rotate(90deg); transform: rotate(90deg);";
      // 注意旋转中点的处理
      style +=
        "-webkit-transform-origin: " +
        width / 2 +
        "px " +
        width / 2 +
        "px;";
      style += "transform-origin: " + width / 2 + "px " + width / 2 + "px;";
    }
    $wrapper.style.cssText = style;
  };
  window.onresize = detectOrient;
  detectOrient();
}


// 环境判断 / 是否微信
export function isWeixn() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

// 环境判断 / 是否支付宝
export function isAlipay() {
  return /AlipayClient/.test(window.navigator.userAgent)
}

export function getBase64(imgUrl) {
  return new Promise((resolve, reject) => {
    // 一定要设置为let，不然图片不显示
    const image = new Image()
    // 解决跨域问题
    image.setAttribute('crossOrigin', 'anonymous')

    const imageUrl = imgUrl
    image.src = imageUrl
    // image.onload为异步加载
    image.onload = () => {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var quality = 0.8
      // 这里的dataurl就是base64类型
      // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      const dataurl = canvas.toDataURL('image/jpeg', quality)
      resolve(dataurl)
    }
  })
}

export function debounce(func, wait = 300, immediate = true) {

  var timeout, result;

  var debounced = function () {
    // @ts-ignore
    var context = this;
    var args = arguments;

    if (timeout) clearTimeout(timeout);
    if (immediate) {
      // 如果已经执行过，不再执行
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) result = func.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args)
      }, wait);
    }
    return result;
  };

  // @ts-ignore
  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

// 院校库数据编辑处理函数
export function commonSchoolInfohandle(data, dataName) {
  let obj = data || {}
  if (!data) {
    if (['schoolList', 'schoolListNot', 'facultyIdAndMajorList'].includes(dataName)) {
      return []
    } else {
      return {}
    }
  }
  if (dataName === 'education') return obj.entity || {}
  else if (dataName === 'school') return obj.extend[2] || {}
  else if (dataName === 'faculty') return obj.extend[3] || {}
  else if (dataName === 'major') return obj.extend[4] || {}
  else if (dataName === 'facultyIdAndMajor') {
    if (data.extend[4]) return data.extend[4]
    else if (data.extend[3]) return data.extend[3]
    else if (data.extend[2]) return {
      text: '未知',
      value: -1
    }
    return obj
  } else if (dataName === 'schoolList') {
    if (obj.extend[2]) return [{
      text: data.extend[2].text,
      value: data.extend[2].value
    }]
    else return []
  } else if (dataName === 'schoolListNot') {
    if (obj.extend[2]) return [{
      text: data.extend[2].text.replace(/\(.*?\)/g, ''),
      value: data.extend[2].value
    }]
    else return []
  } else if (dataName === 'facultyIdAndMajorList') {
    if (obj.extend[4]) return [{
      text: data.extend[3].text + '/' + data.extend[4].text,
      value: data.extend[4].value
    }]
    else if (obj.extend[3]) return [{
      text: data.extend[3].text,
      value: data.extend[3].value
    }]
    else if (obj.extend[2]) return [{
      text: '未知',
      value: -1
    }]
    else return []
  }
}

export function SplicingDatahandel(data, dataName = 'schoolName') {
  if (!data) return null
  let splicingData = ''
  let obj = {}
  let arrData = Object.keys(data)
  for (let index = 0; index < arrData.length; index++) {
    const element = arrData[index]
    if (data[element] !== '-') {
      splicingData += '-' + data[element].text
    }
  }
  return obj[dataName] = splicingData.slice(1)
}


export function debounceFun(func, wait = 500, immediate = true) {
  let timer = null
  return function (...args) {
    const ctx = this
    if (timer) clearTimeout(timer)
    if (immediate) {
      const isTimer = !timer
      timer = setTimeout(() => {
        timer = null
      }, wait)
      if (isTimer) func.apply(ctx, args)
    } else {
      timer = setTimeout(() => {
        func.apply(ctx, args)
      }, wait)
    }
  }
}
